import { LoginForm } from "./LoginForm";

const React = window.React;

function LoginPrompt() {

    const ref = React.useRef();
    const refLoginForm = React.useRef();
    const [isLoading, setIsLoading] = React.useState(false);

    function handleDisplay( mount = true ){

        // Dismiss the tooltip if its open
        $('#login-prompt-tooltip').tooltip('hide');

        if( mount ){
            ref.current.parentElement.classList.remove( 'd-none' );
            ref.current.parentElement.classList.add( 'd-flex' );

            animateLoginPrompt( mount );
        } else {
            setIsLoading( false );
            animateLoginPrompt( mount ).then( () => {
                ref.current.parentElement.classList.remove( 'd-flex' );
                ref.current.parentElement.classList.add( 'd-none' );
            } );
            
        }
    }

    const animateLoginPrompt = ( mount ) => {
        return new Promise((resolve, reject) => {

            if( typeof anime === 'function' ){
                anime({
                    targets: ref.current,
                    opacity: [mount ? 0 : 1, mount ? 1 : 0],
                    duration: 250,
                    easing: 'easeOutQuad',
                    
                })
                anime({
                    targets: refLoginForm.current,
                    opacity: [mount ? 0 : 1, mount ? 1 : 0],
                    translateY: [mount ? 20 : 0, mount ? 0 : 20],
                    duration: 250,
                    easing: 'easeOutQuad',
                    complete: () => {
                        resolve();
                    }
                })
            } else {
                resolve();
            }
        })
    }
    
    React.useEffect(() => {
        window.setLoginFormDisplay = handleDisplay;

        document.dispatchEvent(new Event('adwLoginComponentLoaded'));
        
    }, []);

    const LoginTitle = () => {
        const ref = React.useRef();

        return(
        <div ref={ref}>
        <h4  className=" text-2xl font-semibold mb-3 ">
            Sign In
        </h4>
        <p>Already an Adweek member? Register faster by signing in and enabling autofill.</p>
        </div>
    )}

    return (
        <div ref={ref} className="">
            
            <>
                {/* Modal Dismiss Background */}
                <div
                    className=" w-100 h-100
                        position-absolute top-0 end-0 start-0 bottom-0"
                    style={{background: 'var(--bs-body-bg)', opacity: .7}}
                    onClick={() => handleDisplay(false)}
                ></div>

                {/* Login Form */}
                <div ref={refLoginForm} className="login-prompt position-relative
                    overflow-hidden my-8 mx-4 shadow-lg relative
                    rounded-lg border"
                    style={{background: 'var(--bs-body-bg)'}}
                >

                    {/* Modal Dismiss Button */}
                    <button
                        className="btn dismiss-login-prompt position-absolute end-0
                            d-flex justify-content-center align-items-center
                            p-2 border-0
                        "
                        onClick={() => handleDisplay(false)}
                        type="button"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                        </svg>
                    </button>

                    <div className=" p-4 md:p-8">

                        <LoginForm
                            LoginTitleComponent={LoginTitle}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            rounded={false} dismissCbFn={() => handleDisplay( false )}
                            successCbFn={typeof initConvertrFormForWebinar !== 'undefined' ? initConvertrFormForWebinar : null}

                        />
                    </div>

                    
                </div>
            </>
        </div>
    );
}

export default LoginPrompt;
